export default () => `
<div class="title-contents card">    
    <div class="title TitleCard">
        <div class="TitleHeaderBar"></div>
        <div class="CoverImage"></div>
    </div>

    <div class="TitleInfo"></div>

    <div class="row">
        <div class="columns small-12">
            <div class="title-description"></div>
        </div>
    </div>

    <div class="action-buttons list-view">
        <div class="TitleAction"></div>
        <div class="TitleWishlist is-full"></div>
    </div>
</div>`;
